"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MortgageForm_1 = __importDefault(require("./MortgageForm"));
var SectionHeader_1 = __importDefault(require("../SectionHeader"));
var react_i18next_1 = require("react-i18next");
var MortgageSection = function (_a) {
    var region = _a.region, district = _a.district, address = _a.address, isDeveloper = _a.isDeveloper, freeApartments = _a.freeApartments, mortgage = _a.mortgage, propertyType = _a.propertyType;
    var t = react_i18next_1.useTranslation('common').t;
    return (freeApartments === null || freeApartments === void 0 ? void 0 : freeApartments.length) ? (react_1.default.createElement("div", { className: "section-data" },
        react_1.default.createElement(SectionHeader_1.default, { title: t('POST_PREVIEW.MORTGAGE_INFO').toUpperCase() }),
        react_1.default.createElement(MortgageForm_1.default, { freeApartments: freeApartments, region: region, district: district, address: address, isDeveloper: isDeveloper, mortgage: mortgage, propertyType: propertyType }))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = MortgageSection;
